import React from 'react';
import { Link } from '@vtblife/uikit';

import { SuccessModal } from '@search/vtbeco-frontend-core/view/common/components/SuccessModal/SuccessModal';
import { useLkLinks } from '../../useLkLinks';

type Props = {
    onClose: () => void;
    isMobile?: boolean;
}

export const SaveSearchSuccessModal = ({
    onClose,
    isMobile
}: Props) => {
    const { savedSearchUrl } = useLkLinks();

    return (
        <SuccessModal
            onClose={onClose}
            isMobile={isMobile}
            title='Поиск сохранён'
            mobileDescription={<>
                {/* eslint-disable-next-line max-len */}
                Управлять поисками вы можете в <Link variant='primary-minor' href={savedSearchUrl} target='blank'>Личном кабинете</Link>.
            </>}
            desktopDescription={<>
                Поиск сохранён. <br />
                Управлять поисками вы можете <br />
                в <Link variant='primary-minor' href={savedSearchUrl} target='blank'>Личном кабинете</Link>.
            </>}
        />
    );
};
